interface ClipBoardsSvgProps {
	height?: number;
	width?: number;
}

const ClipBoardsSvg = ({ height = 160, width = 112 }: ClipBoardsSvgProps) => {
	return (
		<svg
			fill="none"
			height={width}
			viewBox="0 0 160 112"
			width={height}
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				fill="#E8F1FD"
				height="70"
				rx="3"
				transform="rotate(-17.1038 33.2317 26.3412)"
				width="61"
				x="33.2317"
				y="26.3412"
			/>
			<rect
				fill="#A1C4F5"
				height="61"
				rx="3"
				transform="rotate(-17.1038 38.2312 28.9879)"
				width="53"
				x="38.2312"
				y="28.9879"
			/>
			<rect
				fill="#1571F0"
				height="9"
				rx="2"
				transform="rotate(-17.1038 47.6417 18.7682)"
				width="29"
				x="47.6417"
				y="18.7682"
			/>
			<circle
				cx="61.3901"
				cy="12.4451"
				r="2.5"
				stroke="#1571F0"
				transform="rotate(-17.1038 61.3901 12.4451)"
			/>
			<rect fill="#E8F1FD" height="70" rx="3" width="61" x="65" y="31" />
			<rect fill="#A1C4F5" height="61" rx="3" width="53" x="69" y="35" />
			<rect fill="#1571F0" height="9" rx="2" width="29" x="81" y="28" />
			<circle cx="96" cy="26" r="2.5" stroke="#1571F0" />
		</svg>
	);
};

export default ClipBoardsSvg;
